import { Component, OnInit } from '@angular/core';
import { TableUtilisateurs } from '../../../../data/schemas/table.schema';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UtilisateurService } from '../../../../services/utilisateur.service';
import { AppService } from '../../../../core/app.service';
import { UiTable } from '../../../../components/ui/table/table.component';
import { ModalComponent } from '../../../../components/modal/modal.component';
import { Input } from '../../../../components/forms/input/input';
import { SelectComponent } from "../../../../components/forms/select/select.component";
import { SelectOption } from '../../../../data/schemas/selectoption.schema';
import { AgentRes } from '../../../../data/http/responses/agent.res';
import { profilData } from '../../../../data/schemas/data/data.schema';
import { AgentService } from '../../../../services/agent.service';
import { UtilisateurReq } from '../../../../data/http/requests/user.req';
import { UiButtonComponent } from '../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../components/ui/Confirmdialog/Confirmdialog.component';

@Component({
  selector: 'app-utilisateurs',
  standalone: true,
  imports: [
    UiTable, ModalComponent, ReactiveFormsModule,
    Input, SelectComponent,
    UiButtonComponent, loaderIntervantion, ConfirmDialogComponent
  ],
  templateUrl: './utilisateurs.component.html',
  styleUrl: './utilisateurs.component.css'
})
export class UtilisateursCrudPage implements OnInit {
  public tableEntity = TableUtilisateurs;
  public showAddEntityModal = false;
  public entities: any[] = [];
  public agents: SelectOption[] = [];
  public profils: SelectOption[] = [];
  public isLoading = false;
  public isEditing = false;
  public editingEntity: any | null = null;

  public showDeleteConfirm = false;
  public selectedItem: any | null = null;
  public deleteLoading = false;

  entityForm!: FormGroup;

  constructor(
    private entityService: UtilisateurService,
    private agentService: AgentService,
    private fb: FormBuilder,
    private AppService: AppService
  ) {
    this.profils = profilData.map(p => ({ value: p.code, label: p.label }));
    this.entityForm = this.fb.group({
      applicationId: this.AppService.getAppId()!,
      agent: ['', Validators.required],
      identifiant: ['', Validators.required],
      motDePasse: ['', Validators.required],
      profil: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadEntities();
    this.loadAgents();
  }

  saveEntity(): void {
    if (this.entityForm.valid) {
      this.isLoading = true;
      const selectedProfile = profilData.find(p => p.code === this.entityForm.value.profil);
      const requestBody: UtilisateurReq = { ...this.entityForm.value, libelle: selectedProfile?.label || '' };

      if (this.isEditing && this.editingEntity) {
        this.entityService.update(this.editingEntity.id, requestBody).subscribe({
          next: () => { this.loadEntities(); this.closeAddEntityModal(); this.isLoading = false; },
          error: (e) => { console.error(e); this.isLoading = false; }
        });
      } else {
        this.entityService.create(requestBody).subscribe({
          next: () => { this.loadEntities(); this.closeAddEntityModal(); this.isLoading = false; },
          error: (e) => { console.error(e); this.isLoading = false; }
        });
      }
    } else {
      this.entityForm.markAllAsTouched();
    }
  }

  loadEntities(): void {
    this.isLoading = true;
    this.entityService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (r: any) => { this.entities = r.data; this.isLoading = false; },
      error: (e) => { console.error(e); this.isLoading = false; }
    });
  }

  loadAgents(): void {
    this.agentService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (r: any) => {
        this.agents = r.data.map((a: AgentRes) => ({ value: a.id, label: a.nom + ' ' + a.prenoms }));
      },
      error: (e) => console.error(e)
    });
  }

  openAddEntityModal(): void {
    this.isEditing = false;
    this.editingEntity = null;
    this._resetForm();
    this.showAddEntityModal = true;
  }

  closeAddEntityModal(): void {
    this.showAddEntityModal = false;
    this.isEditing = false;
    this.editingEntity = null;
    this._resetForm();
  }

  onEditEntity(item: any): void {
    this.isEditing = true;
    this.editingEntity = item;
    this.entityForm.patchValue({
      agent: item.agent?.id,
      identifiant: item.identifiant,
      motDePasse: item.motDepasse,
      profil: item.profil,
      applicationId: this.AppService.getAppId()!
    });
    this.showAddEntityModal = true;
  }

  openDeleteConfirm(item: any): void { this.selectedItem = item; this.showDeleteConfirm = true; }
  cancelDelete(): void { this.showDeleteConfirm = false; this.selectedItem = null; }
  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    this.entityService.delete(this.selectedItem.id).subscribe({
      next: () => { this.loadEntities(); this.deleteLoading = false; this.cancelDelete(); },
      error: (e) => { console.error(e); this.deleteLoading = false; }
    });
  }

  private _resetForm(): void {
    this.entityForm.reset({ applicationId: this.AppService.getAppId()!, agent: '', identifiant: '', motDePasse: '', profil: '' });
  }
}